var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7098 8.21001C18.6169 8.11628 18.5063 8.04189 18.3844 7.99112C18.2625 7.94035 18.1318 7.91422 17.9998 7.91422C17.8678 7.91422 17.7371 7.94035 17.6152 7.99112C17.4934 8.04189 17.3828 8.11628 17.2898 8.21001L12.7098 12.79C12.6169 12.8837 12.5063 12.9581 12.3844 13.0089C12.2625 13.0597 12.1318 13.0858 11.9998 13.0858C11.8678 13.0858 11.7371 13.0597 11.6152 13.0089C11.4934 12.9581 11.3828 12.8837 11.2898 12.79L6.70982 8.21001C6.61685 8.11628 6.50625 8.04189 6.38439 7.99112C6.26253 7.94035 6.13183 7.91422 5.99982 7.91422C5.8678 7.91422 5.7371 7.94035 5.61524 7.99112C5.49338 8.04189 5.38278 8.11628 5.28982 8.21001C5.10356 8.39737 4.99902 8.65083 4.99902 8.91501C4.99902 9.1792 5.10356 9.43265 5.28982 9.62001L9.87982 14.21C10.4423 14.7718 11.2048 15.0874 11.9998 15.0874C12.7948 15.0874 13.5573 14.7718 14.1198 14.21L18.7098 9.62001C18.8961 9.43265 19.0006 9.1792 19.0006 8.91501C19.0006 8.65083 18.8961 8.39737 18.7098 8.21001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleDown);
export default __webpack_public_path__ + "static/media/angle-down.c6dd196100ee8a9f5eac9e45af208740.svg";
export { ForwardRef as ReactComponent };